<template>
  <div>
    <div class="navbar-fixed" style="background-color: rgba(0,0,0,0)">
      <nav v-show="hideNav==='0'" style="background-color: rgba(0,0,0,0)"
           :style="'backgroundColor:'+backgroundColor+';'">
        <div class="nav-wrapper center-align">
          {{backgroundColor}}
          <img class="logo-navbar " :src="image" />
        </div>
      </nav>
    </div>

    <main class="center-align">
      <div class="row center-align main form-card">
        <div class="col card-panel recargas">
          <form>
            <div class="input-field col s12">
              <i
                class="fa fa-building prefix icono-izquierda"
                aria-hidden="true"
              ></i>

              <select v-model="tipoRecarga">
                <option value="ICC">Por icc</option>
                <option value="DN">Por dn</option>
              </select>
              <label>Tipo de recarga</label>
            </div>

            <div v-show="tipoRecarga === 'ICC'" class="input-field col s12">
              <i class="material-icons prefix icons-down" aria-hidden="true"
                >sim_card</i
              >
              <input
                v-model="icc"
                id="icc"
                type="tel"
                maxlength="19"
                class="validate"
              />
              <label for="icc">Icc</label>
            </div>
            <div v-show="tipoRecarga === 'ICC'" class="input-field col s12">
              <i
                class="fa fa-check-circle prefix icons-down"
                aria-hidden="true"
              ></i>
              <input
                v-model="confirmacionIcc"
                id="confirmacion-icc"
                type="tel"
                maxlength="19"
                class="validate"
              />
              <label for="confirmacion-icc">Confirmación de icc</label>
            </div>

            <div class="input-field col s12">
              <i class="fa fa-phone prefix icons-down" aria-hidden="true"></i>
              <input
                v-model="telefono"
                id="telefono"
                type="tel"
                maxlength="10"
                class="validate"
              />
              <label for="telefono">Número telefonico</label>
            </div>
            <div v-show="tipoRecarga === 'DN'" class="input-field col s12">
              <i
                class="fa fa-check-circle prefix icons-down"
                aria-hidden="true"
              ></i>
              <input
                v-model="confirmacionTel"
                id="confirmacion-telefono"
                type="tel"
                maxlength="10"
                class="validate"
              />
              <label for="confirmacion-telefono">Confirmación de número</label>
            </div>

            <span class="mensaje-error col s12">{{ mensaje }}</span>
            <div v-show="isRecargando" class="progress barraMovimientos">
              <div class="indeterminate"></div>
            </div>
            <div v-show="!isRecargando" class="barra-invisible"></div>
            <div
              v-show="!isRecargando"
              class="waves-effect waves-light btn-large blue-grey darken-3 push-s1 "
              @click="enviar"
            >
              <i class="fa fa-check left" aria-hidden="true"></i> Recargar
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {recargaSinUsuario, getEmpresa, setTheme, iniciarSesionUsario, recargar} from "@/api/api";
import { mapState } from "vuex";

let gEmpresa = "";
let intento = 1;
export default {
  name: "recargaa",
  data() {
    return {
      mensaje: " ",
      telefono: "",
      confirmacionTel: "",
      confirmacionIcc: "",
      icc: "",
      tipoRecarga: "ICC",
      isRecargando: false,
      empresa: "",
      username: null
    };
  },
  mounted() {
    this.empresa = this.$route.params.empresa;
    this.username = this.$route.params.username;
     if(this.username)
       iniciarSesionUsario(this.username, this.empresa).then(respuesta => {
         console.log(respuesta, `esta es la respuesta`)
         this.$store.commit('quitarBarra')
         if (respuesta.token) {
           this.msg = ''
           localStorage.setItem('empresa', gEmpresa)
           localStorage.setItem('maxRecargas', respuesta.empresa.maxRecargas)
           localStorage.setItem('recargaSinUsuario', respuesta.empresa.recargaSinUsuario)
           localStorage.removeItem('token')
           localStorage.removeItem('nivel2')
           localStorage.removeItem('id')
           localStorage.removeItem('nombre')
           localStorage.setItem('nivel', respuesta.nivel)
           localStorage.setItem('isMonto', respuesta.isMonto)
           localStorage.setItem('username', respuesta.username)
           window.localStorage.setItem('MRD', respuesta.MRD)
           localStorage.setItem('token', respuesta.token)

         } else {
           this.msg = 'Error inesperado, intente mas tarde'
         }
         if (gEmpresa == `demo`) {
           console.log(`es demo`)
           // setTokenSentToServer(false)
           // refreshToken()
         }

       }).catch(error => {
         this.$store.commit('quitarBarra')
         console.log(error)
         this.errorCode = error.code ? error.code : 1
         this.qrCodeUrl = error.qrCodeUrl ? error.qrCodeUrl : ''
         this.msg = error.mensaje ? error.mensaje : 'Usuario o contraseña incorrectos, intenta de nuevo'
         this.msg = this.errorCode == 14 ? '' : this.msg
         this.$router.push({
           name: "login",
           params: { empresa: this.empresa },
         });

       })
    console.log("wea:", this.empresa);
    this.$nextTick(() => M.AutoInit());
  },
  beforeCreate() {
    let auxEmpresa = this.$route.params.empresa;
    this.empresa = this.$route.params.empresa;
    if (auxEmpresa === "login") {
      const dominio = window.location.href;
      if (dominio.includes("herramientasbaevi.com")) auxEmpresa = "baevi";
      else if (dominio.includes("gmcel.com")) auxEmpresa = "gmcel";
      else if (dominio.includes("gruposima.mx")) auxEmpresa = "gruposima";
      else if (dominio.includes("enlaceshop.com")) auxEmpresa = "enlaceshop";
      else if (dominio.includes("recargasgsmoviles.com.mx"))
        auxEmpresa = "gsmoviles";
      else if (dominio.includes("recargastgmex.mx")) auxEmpresa = "tgmex";
      else if (dominio.includes("recargasasec.com")) auxEmpresa = "asec";
      else if (dominio.includes("recargasdraggomovil.com"))
        auxEmpresa = "draggomovil";
      else if (dominio.includes("leiphone.com.mx")) auxEmpresa = "leiphone";
      else if (dominio.includes("damtel")) auxEmpresa = "damtel";
      else if (dominio.includes("recargaszaz.com.mx")) auxEmpresa = "leiphone";
      else if (dominio.includes("cmtex.com.mx")) auxEmpresa = "cmtex";
      else if (dominio.includes("activasimrecargas.com"))
        auxEmpresa = "activasim";
      else if (dominio.includes("simcroft")) auxEmpresa = "simcroft";
      else if (dominio.includes("innova")) auxEmpresa = "innova";
      else if (dominio.includes("discovery")) auxEmpresa = "discovery";
      else if (dominio.includes("devsol")) auxEmpresa = "devsol";
      else if (dominio.includes("tridial")) auxEmpresa = "tridial";
      else if (dominio.includes("movicell")) auxEmpresa = "movicell";
      else if (dominio.includes("todosim")) auxEmpresa = "todosim";
      else if (dominio.includes("eradigital")) auxEmpresa = "eradigital";
      else if (dominio.includes("silverphone")) auxEmpresa = "silverphone";
      else if (dominio.includes("celstar")) auxEmpresa = "celstar";
      else if (dominio.includes("vam")) auxEmpresa = "vam";
      else if (dominio.includes("aba")) auxEmpresa = "damtel";
    }
    this.empresa = auxEmpresa;
    console.log(auxEmpresa);
    gEmpresa = auxEmpresa;
    console.log(`antes del mntenioajanh`, intento);
    if (intento === 1) {
      console.log(`entyro al imntentomjnwqk `, intento);
      getEmpresa(gEmpresa)
        .then((response) => {
          localStorage.setItem("empresa", gEmpresa);
          console.log(`hizo la peti`, intento);
          console.log(response.empresa);
          console.log("recargas:", response.empresa.recargaSinUsuario);
          const permiso = response.empresa.recargaSinUsuario;
          if (permiso == 0)
            this.$router.push({
              name: "login",
              params: { empresa: this.empresa },
            });

          console.log(response.empresa.backgroundColor)
          this.$store.commit("theming", response.empresa);
          setTimeout(() => {
            this.gettedVideo = response.empresa.imagenFondo !== "";
          }, 10);
          const empresa = response.empresa;
          console.log(empresa.primaryColor,
              empresa.darkenColor,
              empresa.accentColor)


          setTheme(
            document,
            empresa.primaryColor,
            empresa.darkenColor,
            empresa.accentColor
          );
        })
        .catch((error) => {
          console.log(error);
          intento = 2;
          console.log(`error ene elro `, intento);
          M.toast({
            html: error.message,
            classes: "rounded",
            displayLength: 10000,
          });
          this.$router.push({ name: "sinEmpresa" });
        });
    }
  },
  methods: {
    enviar() {
      if (this.tipoRecarga === "ICC") {
        if (!this.hasMoviDnPermit) this.telefono = "";
        if (this.icc.trim() === "" || this.icc.trim().length > 20)
          return (this.mensaje = " Introduce un icc valido");
        if (this.confirmacionIcc.trim() === "")
          return (this.mensaje = " Introduce la confirmación del icc ");
        if (this.confirmacionIcc !== this.icc)
          return (this.mensaje = "Los dos Icc no coinciden");
      } else {
        this.icc = "";
        if (this.telefono.trim() === "" || this.telefono.trim().length !== 10)
          return (this.mensaje = " Introduce un teléfono válido");
        if (this.confirmacionTel.trim() === "")
          return (this.mensaje = " Introduce la confirmación del teléfono ");
        if (this.confirmacionTel !== this.telefono)
          return (this.mensaje = "Los dos números no coinciden");
      }
      this.mensaje = " ";
      if (this.isRecargando)
        return (this.mensaje = "Ya se está realizando una recarga");
      this.isRecargando = true;
      this.$store.commit("ponerBarra");
      let objetoaEnviar = {};
      objetoaEnviar.icc = this.icc;
      objetoaEnviar.dn = this.telefono;

      objetoaEnviar.origin = `web`;

      if(this.username && window.localStorage.token){
        recargar(
            objetoaEnviar
        )
            .then((respuesta) => {
              this.isRecargando = false;

              this.$store.commit("quitarBarra");
              let auxMessage = "Recarga exitosa";
              if (respuesta.message) auxMessage = respuesta.mensaje;
              else if (respuesta.mensaje) auxMessage = respuesta.mensaje;
              this.mensaje = auxMessage;
              document.getElementById("player").play();
              M.toast({
                html: `${auxMessage}`,
                classes: "rounded",
                displayLength: 150000,
              });
              this.limpiar();
            })
            .catch((error) => {
              this.isRecargando = false;

              this.$store.commit("quitarBarra");
              let auxMessage = "Recarga fallida";
              if (error.message) auxMessage = error.mensaje;
              else if (error.mensaje) auxMessage = error.mensaje;
              this.mensaje = auxMessage;

              M.toast({
                html: `${auxMessage}`,
                classes: "rounded",
                displayLength: 150000,
              });
            });
      }
      else
        recargaSinUsuario(objetoaEnviar, this.empresa)
          .then((respuesta) => {
            this.isRecargando = false;
            this.$store.commit("quitarBarra");
            let auxMessage = "Recarga exitosa";
            if (respuesta.message) auxMessage = respuesta.mensaje;
            else if (respuesta.mensaje) auxMessage = respuesta.mensaje;
            this.mensaje = auxMessage;

            M.toast({
              html: `${auxMessage}`,
              classes: "rounded",
              displayLength: 150000,
            });
            this.limpiar();
          })
          .catch((error) => {
            this.isRecargando = false;
            this.$store.commit("quitarBarra");
            let auxMessage = "Recarga fallida";
            if (error.message) auxMessage = error.mensaje;
            else if (error.mensaje) auxMessage = error.mensaje;
            this.mensaje = auxMessage;

            M.toast({
              html: `${auxMessage}`,
              classes: "rounded",
              displayLength: 150000,
            });
          });
    },
  },
  computed: {
    ...mapState([
      "primaryColor",
      "accentColor",
      "accentColor",
      "backgroundColor",
      "image",
      "imagenFondo",
      "izquierdoLogin",
      "hideNav",
    ]),
  },
};
</script>

<style scoped>
.navbar-fixed {
  margin-top: -5px;
}

.logo-navbar {
  max-height: 80%;
  margin-top: 10px;
}
.btn-large {
  border-radius: 10px;
}
.icons-down {
  margin-left: -10px;
}
.form-card {
  display: contents;
}
.titulo {
  font-size: 2.2em;
  display: block;
  margin-top: 5px;
  font-family: "Roboto", serif;
  font-weight: lighter;
}

.prefix {
  font-size: 1.4em;
  margin-top: 10px;
}

.card-panel {
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 10px;
}

.icono-izquierda {
  left: 0;
}

.left {
  margin-left: 10px;
}

.recargas {
  width: 31%;
}
.main {
  margin-top: 20px;
}
main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
.mensaje-error {
  font-size: 1.5em;
  margin-bottom: 15px;
  font-family: "Roboto", serif;
  color: #b80009;
}

td,
th {
  padding: 10px 5px;
}

.barraMovimientos {
  max-width: 100%;
  position: relative;
}
@media (max-width: 800px) {
  .recargas {
    width: 94%;
  }

  .movimientos {
    width: 94%;
  }
}


</style>
